/**
 * Get the current page URL
 * 
 * @returns {URL} window.location as an URL object
 */
export const getPageUrl = () => {
  return new URL(window.location);
};
